import { render } from "./CameraCapture.vue?vue&type=template&id=79708a25"
import script from "./CameraCapture.vue?vue&type=script&lang=js"
export * from "./CameraCapture.vue?vue&type=script&lang=js"

import "./CameraCapture.vue?vue&type=style&index=0&id=79708a25&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__